import app from '../api/app';
import Cookies from 'universal-cookie';
import DOMPurify from 'dompurify';

import { formatStrings } from '../components/functions';
import { Wait } from '../components/wait';

import { clearUserInfo } from '../app/store';

export { login, signout, forceSignout, requestPasswordReset, resetPassword, googleLogin } from './paths/auth';

export { fetchStampParams } from './paths/_stampParams';
export {
    fetchAdminUsersAll, fetchAdminUsersActive, fetchAdminUsersIds,
    createAdminUser, updateAdminUser, updateAdminUserPassword, deleteAdminUser
} from './paths/adminUsers';
export {
    fetchAppointmentsDateCenter, fetchAppointmentsDateOnly, fetchAppointmentsDaterangeStudent,
    fetchAppointmentsDaterangeCenterStudentName, fetchAppointmentsDaterange, fetchAppointmentsIds,
    createAppointment, updateAppointmentCore, updateAppointmentStatus,
    updateAppointmentDetails, deleteAppointment, createAppointmentsBulk,
    updateAppointmentInstructors, updateAppointmentStampsGiven, deleteAppointmentForce,
    fetchMemberAppointmentsParentStudent, fetchMemberAppointmentsUnified
} from './paths/appointments';
export {
    fetchAssessmentTemplatesAll, fetchAssessmentTemplatesFull, fetchAssessmentTemplatesId,
    createAssessmentTemplate, updateAssessmentTemplate, deleteAssessmentTemplate
} from './paths/assessmentTemplates';
export {
    fetchAssessmentsId, fetchAssessmentsDaterangeCenter, fetchAssessmentsStudentIds,
    createAssessment, updateAssessment, deleteAssessment
} from './paths/assessments';
export {
    fetchAutoScheduleItemsAll, fetchAutoScheduleItemsIds, createAutoScheduleItem,
    fetchAutoScheduleItemsCenter, updateAutoScheduleItem, deleteAutoScheduleItem
} from './paths/autoScheduleItems';
export { fetchMpCentersAll, fetchRpCentersAll } from './paths/centers';
export {
    fetchContractsDaterangeCenter, fetchContractsIds, fetchCurrentContractsStudentIds, fetchContractsStudentIds,
    fetchContractsActiveStudents, fetchRpContractsActiveStudents, fetchMpContractsActiveStudents, fetchMpContractsIds,
    fetchContractsStudentNames, createContract, updateContract,
    updateContractEndDateOffset, deleteContract
} from './paths/contracts';
export {
    fetchDailyReportDateCenter, fetchDailyReportsDaterangeCenter,
    createDailyReport, updateDailyReport
} from './paths/dailyReport';
export { fetchEmailLogs } from './paths/emailLogs';
export {
    fetchExtraTagsAll, fetchExtraTagsIds, createExtraTag,
    updateExtraTag, deleteExtraTag
} from './paths/extraTags';
export {
    fetchFlagsDaterange, fetchFlagsIds, fetchFlagsStatus, createFlag,
    updateFlag, deleteFlag, fetchFlagsKanban, updateFlagKanbanStatus, updateFlagsKanbanOrder
} from './paths/flags';
export {
    fetchProjectsAll, fetchProjectsId, fetchProjectsStatus,
    createProject, updateProject, deleteProject
} from './paths/projects';
export {
    fetchBooksAll, fetchBooksActive, fetchBooksId, fetchBooksTerm,
    createBook, updateBook, deleteBook
} from './paths/books';
export {
    fetchBookListsAll, fetchBookListsActive, fetchBookListsId, fetchBookListsStudents,
    createBookList, updateBookList, deleteBookList, fetchBookListItemsAll
} from './paths/bookLists';
export {
    fetchBookStudentDatesByBook, fetchBookStudentDatesByStudentBook, fetchBookStudentDatesByBookList,
    saveBookStudentDate, updateBookStudentDate, deleteBookStudentDate
} from './paths/bookStudentDates';
export {
    fetchBookListTemplatesAll, fetchBookListTemplatesFull, fetchBookListTemplatesId,
    createBookListTemplate, updateBookListTemplate, deleteBookListTemplate
} from './paths/bookListTemplates';
export {
    fetchCycleGroupsAll, fetchCycleGroupsActive, fetchCycleGroupsId,
    createCycleGroup, updateCycleGroup, deleteCycleGroup
} from './paths/cycleGroups';
export {
    fetchMemberRequestsAll, fetchMemberRequestsId,
    createMemberRequest, updateMemberRequest, deleteMemberRequest
} from './paths/memberRequests';
export {
    fetchHoldsLogsDaterangeCenter, fetchHoldsLogsIds,
    createHoldsLog, updateHoldsLog, deleteHoldsLog
} from './paths/holdsLog';
export { fetchInstructorAppointmentAssignments } from './paths/instructorAppointmentAssignments';
export {
    fetchInstructorAttendanceDaterangeUserIds, fetchInstructorAttendanceIds,
    fetchInstructorAttendanceLatestId, fetchInstructorAttendanceCurrentId,
    signIn, signOut, createAttendance, updateAttendance, deleteAttendance
} from './paths/instructorAttendance';
export {
    fetchLeadsAll, fetchLeadsIds, fetchLeadsMpPermissions, fetchLeadsRpPermissions, createLead,
    updateLead, convertLead, deleteLead
} from './paths/leadUsers';
export {
    fetchLearningPlansId, fetchLearningPlansStudent, createLearningPlan,
    updateLearningPlan, updateLearningPlanComplete, deleteLearningPlan
} from './paths/learningPlans';
export { fetchMemberLearningPlansStudent } from './paths/memberLearningPlans';
export { fetchLearningPlanItemsStudentDaterangeCompleted, updateLearningPlanItems } from './paths/learningPlanItems';
export { fetchLessonsAll, fetchLessonsId, createLesson, updateLesson, deleteLesson } from './paths/lessons';
export {
    fetchMembersAll, fetchMembersIds, fetchMembersMpPermissions, fetchMembersRpPermissions,
    createMember, updateMember, updateMemberPassword, resendMemberWelcome,
    deleteMember
} from './paths/memberUsers';
export {
    fetchPaymentsContractIds, fetchPaymentsDaterangeCenter, fetchPaymentsIds,
    createPayment, updatePayment, deletePayment
} from './paths/payments';
export {
    fetchMemberOverduePayments, createStripeCheckoutSession, fetchMemberPaymentHistory
} from './paths/memberPayments';
export {
    fetchAvailabilityDateCenter, fetchAvailabilityDaterange, fetchAvailabilityDaterangeCenter,
    createAvailability, updateAvailability, deleteAvailability,
    createAvailabilityBulk, deleteAvailabilityBulk
} from './paths/schedulerAvailability';
export { fetchAvailabilityBlocks } from './paths/schedulerAvailabilityBlocks';
export { fetchSchedulerSettings, updateSchedulerSettings } from './paths/schedulerSettings';
export { fetchServerTime, fetchServerDatabase } from './paths/server';
export { fetchSiteAnnouncements, updateSiteAnnouncements } from './paths/siteAnnouncements';
export {
    fetchStampsLogsDaterange, fetchStampsLogsIds, createStampsLog,
    updateStampsLog, deleteStampsLog
} from './paths/stampsLogs';
export { fetchStudentAttendanceHistory } from './paths/studentAttendanceHistory';
export {
    fetchStudentsAll, fetchStudentsActive, fetchStudentsEssential, fetchStudentsCenter,
    fetchStudentsUserIds, updateStudentAttributes, updateStudentBinder, updateStudentStamps,
    fetchMemberStudentsRelevant, fetchMemberStudentsUnified,
    updateStudentContract, updateStudentHold
} from './paths/students';
export { fetchTextLogs } from './paths/textLogs';
export {
    fetchUpcomingExamsAll, fetchUpcomingExamsIds, fetchUpcomingExamsStudents,
    updateUpcomingExams, deleteUpcomingExams
} from './paths/upcomingExams';
export { fetchRelevantInfoMemberDaterangeStudentName } from './paths/xRelevantInfo';

export { setPendingFlags } from './localPaths/notifications';
export { updateConnections } from './localPaths/socket';

const cookies = new Cookies();

// Attempts the specified action with the access token currently stored in the broswer cookie.
// If the access token has expired, the refresh token is used in an attempt to get a new access token.
// If the refresh token has expired, the user will be signed out.
export const attemptAction = async (action, dispatch, params = {}) => {
    // Sanitize and escape ' for SQL use
    const sanitizedParams = JSON.parse(DOMPurify.sanitize(JSON.stringify(formatStrings(params))));

    // Attempt action with currently stored acces token
    const aToken = cookies.get('aToken');
    sanitizedParams.aToken = aToken;

    let response = { status: 999 };
    if (aToken) {
        try {
            response = await action(sanitizedParams);
        } catch (e) {
            console.error(e);
        } finally {
            if (!response || !response.status) return response || {};

            // 401 will be used for expired or otherwise invalid tokens
            if ([401, 999].includes(response.status)) {
                let tokenResponse = await refreshToken();

                // Try one more time if the first request failed
                // This should hopefully limit premature signouts
                if (!tokenResponse?.data?.message || tokenResponse?.status === 401) {
                    await Wait(500);
                    tokenResponse = await refreshToken();
                }

                // Token response status should either be 200, 401, or 500
                if (!tokenResponse || tokenResponse.status === 500) return tokenResponse;

                // 401 should only be be returned if the refresh token has expired
                if (tokenResponse.status === 401) {
                    dispatch(clearUserInfo());
                    return response;
                }

                // If new token received, retry action
                const aToken = tokenResponse.data?.aToken;
                if (!aToken) return {};

                cookies.set('aToken', tokenResponse.data.aToken, { path: '/' });
                sanitizedParams.aToken = aToken;

                // return await action(sanitizedParams);
                const response2 = await action(sanitizedParams);
                return response2;
            } else {
                return response || {};
            }
        }
    } else {
        dispatch(clearUserInfo());
        return response;
    }
}

const refreshToken = async () => {
    const rToken = cookies.get('rToken');
    if (!rToken) return {};

    // Detect portal from domain - CRITICAL: member portals must use /memberAuth, not /adminAuth
    const hostname = window.location.hostname;
    const isMemberPortal = hostname.includes('member.');
    const portal = hostname.includes('readingplex') ? 'rp' : 'mp';
    const authEndpoint = isMemberPortal ? '/memberAuth/request-new-token' : '/adminAuth/request-new-token';

    let response = null;
    try {
        response = await app.post(authEndpoint, {
            rToken,
            portal
        });
    } catch (e) {
        response = e.response;
        console.error('[REFRESH_TOKEN] Error:', e);
    } finally { }

    return response || {};
}